exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-fd0b39cc] .vue-treeselect__control,[data-v-fd0b39cc] .vue-treeselect__placeholder,[data-v-fd0b39cc] .vue-treeselect__single-value{height:30px;line-height:30px}", ""]);

// exports
